(() => {
  // Gentle friction only: preserve normal navigation, selection and accessibility.
  document.addEventListener('dragstart', event => {
    if (event.target.matches('img,video')) event.preventDefault();
  });
  document.querySelectorAll('video').forEach(video => {
    video.setAttribute('controlslist', 'nodownload');
    video.disablePictureInPicture = true;
  });
  const dialog = document.createElement('dialog');
  dialog.id = 'media-viewer'; dialog.className = 'media-viewer';
  dialog.setAttribute('aria-label','Image preview');
  const close = document.createElement('button'); close.type = 'button';
  close.className = 'media-viewer-close'; close.textContent = 'Close ×';
  const surface = document.createElement('div'); surface.className = 'media-viewer-photo';
  const image = document.createElement('img'); surface.append(image); dialog.append(close,surface);document.body.append(dialog);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-media-preview]');
    if (!link) return;
    event.preventDefault();image.src = link.dataset.mediaPreview;
    image.alt = link.querySelector('img')?.alt || 'Icons The Case image';
    dialog.showModal();
  });
  close.addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{
    if(event.target!==dialog)return;
    const r=dialog.getBoundingClientRect();
    if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();
  });
})();
